export class AuditHistory {
    public LocationName:string;
    public LastCompleted:Date;
    constructor(values: Object = {}){
        Object.assign(this, values);     
    }
}